/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import './App.css';
import { currentPlayer } from './atom/atoms';
import TutorialModel from './components/TutorialModel';
import Garden from './Levels/Level-1';
import BasketBall from './Levels/Level-2';
import Bridge from './Levels/Level-3';
import Switch from './Levels/Level-4';
import Lint from './Levels/Level-5';
import Fan from './Levels/Level-6';
import Tutorial from './Levels/Tutorial';
import { addToLeaderBoard } from './utils/leaderBoard';

const levelMappings = {
  0: {
    textAreaLabel: "#text-container",
    Level: Tutorial,
    hint: "Change the text color to white",
    question: "I hate the blue text, White color should be more clean",
    maxTime: 6000,
    existingCss: "color: blue;",
    placeholder: "Enter CSS for the element #text-container",
    levelMultiplier: 0
  },
  1: {
    textAreaLabel: "#sand",
    Level: Garden,
    hint: "Change the sand color",
    question: "The plant cannot grow on grey sand. It needs brown sand. Can you change it to brown?",
    maxTime: 60,
    existingCss: "background-color: lightgray;",
    placeholder: "Enter CSS for the element #sand",
    levelMultiplier: 1,
  },
  3: {
    textAreaLabel: "#purple-block",
    Level: BasketBall,
    hint: "Remove the purple block, so that the basket ball fells down",
    question: "Can you make the ball fall inside the basket?",
    maxTime: 60,
    existingCss: "position: absolute;\ntop: 100px;\nleft: 275px;",
    placeholder: "Enter CSS for the element #purple-block",
    levelMultiplier: 1.3,
  },
  5: {
    textAreaLabel: "#wooden-blocks-container",
    Level: Bridge,
    hint: "Arrange all the wooden blocks horizontally",
    question: "The van needs to cross the river. Can you build a bridge for the van?",
    maxTime: 90,
    existingCss: "display:flex;\nflex-direction:column;",
    placeholder: "Enter CSS for the element #wooden-blocks-container",
    levelMultiplier: 1.9,
  },
  4: {
    textAreaLabel: "#hand",
    Level: Switch,
    hint: "Move the hand to right to turn on the switch",
    question: "Its dark in here, can you turn on the light bulb?",
    maxTime: 90,
    existingCss: "position: absolute;\nleft: 10px;",
    placeholder: "Enter CSS for the element #hand",
    levelMultiplier: 1.3,
  },
  2: {
    textAreaLabel: "Code",
    Level: Lint,
    hint: undefined,
    question: "Fix the linting issues",
    maxTime: 60,
    existingCss: false,
    placeholder: "Fix the linting issues",
    defaultValue: "function add(a,b){\nreturn a+b\n}",
    levelMultiplier: 0.9,
  },
  6: {
    textAreaLabel: "#level-adjuster",
    Level: Fan,
    hint: "Put off the candle by changing the speed of the fan",
    question: "Can you put off the candle?",
    maxTime: 90,
    existingCss: undefined,
    placeholder: "Enter CSS for the element #level-adjuster",
    levelMultiplier: 1.4,
  }
}

const tutorialDetails = {
  1: {
    title: "Tutorial",
    description: "Welcome to Frontend Warrior, lets look at how to play this game!!!"
  },
  2: {
    title: "Objectives",
    class: "level-hint",
    description: 'Here, you can find the objective of the level. \nThe "Show Hint" button when clicked, shows a logical hint to solve the level. You will loose 5 points when you check the hints. \nTry clicking the "Show Hint" button'
  },
  3: {
    title: "Timer",
    class: "level-timer",
    description: "Here, you can see the timer for the level.\n When the timer reaches zero, you loose the level.\n You should complete the level before the timer ends.\n The faster you complete, the higher your score will be"
  },
  4: {
    title: "Game Scene",
    class: "level",
    description: 'Here, you can see the scene which you will be modifying in order to complete the level. \n\n Notice the #text-container ? \nIts the id of the element that contains the text "Welcome to Frontend Warrior"'
  },
  5: {
    title: "Input Section",
    class: "inputArea",
    description: 'Here, you can see a reference to #text-container in the scene. This is were you will be entering your solution to solve the level.\n\nYou might be seeing a button called "Show existing CSS", which will show the existing CSS of the element #text-container. Clicking on the button will reduce 10 points from the score.\n\n Try clicking the "Show Existing CSS" button'
  },
  6: {
    title: "Text Area",
    class: "inputArea",
    description: `In the text area, you can enter the solution/CSS. \nOnce you enter an input, you can try out your solution by clicking "Apply" button. You can try out any number of solutions using the "Apply" button. If your solution is correct, you will complete the level. \nMessed up your solution? You can reset the level by clicking the "Reset" button (You can't reset your timer tho). `
  },
  7: {
    title: "Text Area",
    class: "inputArea",
    description: `Now let's solve this level. \n Try entering the css  color:white;  and apply it`
  }
}

const styles = {
  textArea: {
    "font-size": "x-large",
  },
  textAreaParent: {
    "background-color": "rgba(93, 8, 115, 1)",
    "height": "500px",
    "text-align": "left",
    "display": "flex",
    "flex-direction": "column"
  }
}

const Game = () => {
  const [name, setName] = useRecoilState(currentPlayer);
  const navigate = useNavigate();
  const [level, setLevel] = useState(0);
  const [levelComplete, setLevelComplete] = useState(false);
  const [input, setInput] = useState();
  const [css, setCSS] = useState();
  const [time, setTime] = useState(0);
  const [score, setScore] = useState(0);
  const [timerId, setTimerId] = useState();
  const [firstRender, setFirsRender] = useState(true);
  const [showHint, setShowHint] = useState(false);
  const [showExistingCSS, setShowExistingCSS] = useState(false);
  const [tutorialSteps, setTutorialSteps] = useState(1);

  const { hint, question, Level, textAreaLabel, maxTime, existingCss, defaultValue, placeholder, levelMultiplier } = levelMappings[level];

  useEffect(() => {
    setTime(maxTime);
    if (defaultValue) {
      setInput(defaultValue);
      setCSS(defaultValue);
    }
    console.log(`Score for level ${level} is`, score);
  }, [level]);

  useEffect(() => {
    if (time === 0 && !firstRender) {
      setLevelComplete(true);
    }
  }, [time]);

  // timer logic
  useEffect(() => {
    if (!timerId && !firstRender && !levelComplete) {
      const intervalTimerId = setInterval(() => {
        setTime(time => {
          if (time > 0) return time - 1;
          return time;
        });
      }, 1000);
      setTimerId(intervalTimerId)
    }
    if (firstRender) setFirsRender(false);
  }, [timerId, firstRender, levelComplete]);

  useEffect(() => {
    if (levelComplete && level !== 0) {
      let offset = 0;
      if (showHint) {
        offset += -5
      }
      if (showExistingCSS) {
        offset += -10
      }
      setScore(score => {
        if (time > 0) {
          return (score + (time * levelMultiplier) + offset)
        }
        else {
          return (score + (time * levelMultiplier))
        }
      });
      clearInterval(timerId);
      setTimerId();
    };
  }, [levelComplete]);

  const incrementLevel = () => {
    return setLevel(level => {
      return level + 1;
    });
  }

  if (!name) {
    navigate('/');
  }

  return (
    <div className="App">
      {/* <button onClick={incrementLevel}>Next level</button> */}
      <p style={{ "margin": "10px" }}>Level {level}</p>
      <p className="level-timer" style={{ "fontSize": "xx-large", "color": "yellow", "margin": "10px" }}>Time Left: {time}</p>
      <main>
        <div className="level-hint">
          <h3 style={{ "margin": "0px", "color": "yellow" }}>Objective</h3>
          <p id="level-question">{question}</p>
          {hint && (showHint ? <p>Hint: {hint}</p> : <button disabled={tutorialSteps < 2} onClick={() => { setShowHint(true) }}>Show Hint (-5)</button>)}
        </div>
        <div className="level">
          <Level css={css} onComplete={() => setLevelComplete(true)} />
        </div>
        <div className="inputArea">
          {levelComplete && (levelComplete && time === 0 ?
            <>
              <img alt='failed' height={200} src='/images/fail-stamp.png' />
              <p style={{ "font-size": "xx-large" }}>You ran out of time</p>
            </> :
            <div style={{ "display": "flex", "flexDirection": "column", "alignItems": "center" }}>
              <img alt='success' height={200} width={200} src='/images/success.png' />
              <p style={{ "font-size": "xx-large" }}>Level Completed</p>
            </div>
          )}
          {levelComplete ?
            level + 1 > Object.keys(levelMappings).length - 1 ?
              <>
                Your Score: {score}
                <button onClick={() => {
                  addToLeaderBoard(new Date().getMilliseconds(), name, score);
                  setName('');
                  navigate('/');
                }}>Done</button>
              </>
              : <button onClick={() => {
                setInput("");
                setCSS(undefined);
                setTime(-1);
                setShowHint(false);
                setLevelComplete(false);
                setShowExistingCSS(false);
                incrementLevel();
              }}>Next level</button>
            : (
              <>
                <label style={{ "textAlign": "left" }}>{textAreaLabel}</label>
                <div style={{ ...styles.textAreaParent, backgroundColor: "rgba(93, 8, 115, 1)" }}>
                  {existingCss !== false ? "{" : null}
                  {existingCss ? (showExistingCSS ? <pre style={{ margin: 0 }}>{existingCss}</pre> : <button disabled={tutorialSteps < 5} onClick={() => setShowExistingCSS(true)} style={{ marginBottom: "10px", width: "400px", "align-self": "center" }}>Show Existing CSS (-10)</button>) : null}
                  <textarea placeholder={placeholder} style={styles.textArea} value={input} onChange={(e) => setInput(e.target.value)} />
                  {(existingCss !== false) ? "}" : null}
                </div>
                <div style={{ marginTop: "10px" }} className='button-container'>
                  <button disabled={tutorialSteps < 5} onClick={() => { setCSS(defaultValue || ""); setInput(defaultValue || ""); }} className="secondary">Reset</button>
                  <button disabled={tutorialSteps < 5} onClick={() => setCSS(input)} className="primary">Apply</button>
                </div>
              </>
            )}
        </div>
      </main>
      <TutorialModel
        title={tutorialDetails[tutorialSteps]?.title}
        description={tutorialDetails[tutorialSteps]?.description}
        className={tutorialDetails[tutorialSteps]?.class}
        onNext={() => setTutorialSteps(tutorialSteps + 1)}
        bottom="10px"
        left="10px"
      />
    </div >
  );
}

export default Game;
